// src/actions/customer_actions.js
//
// Braze-backed customer journey for the order-details page:
// acquisition/UTM, marketing opt-ins, campaigns & canvases received, devices.

import axios from "axios";
import {
  FETCH_CUSTOMER_JOURNEY_LOADING,
  FETCH_CUSTOMER_JOURNEY_SUCCESS,
  FETCH_CUSTOMER_JOURNEY_FAIL,
} from "./types";

export const fetchCustomerJourney = (email) => async (dispatch) => {
  dispatch({ type: FETCH_CUSTOMER_JOURNEY_LOADING });
  try {
    const token = localStorage.getItem("jwtToken");
    const url = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureApi/analytics/customer/journey`;
    const resp = await axios.get(url, {
      headers: { Authorization: `Bearer ${token}` },
      params: { email },
    });
    if (resp.data?.success) {
      dispatch({ type: FETCH_CUSTOMER_JOURNEY_SUCCESS, payload: resp.data.data });
    } else {
      dispatch({
        type: FETCH_CUSTOMER_JOURNEY_FAIL,
        payload: resp.data?.message || "Failed to fetch customer journey",
      });
    }
  } catch (err) {
    dispatch({
      type: FETCH_CUSTOMER_JOURNEY_FAIL,
      payload:
        err.response?.data?.message || err.message || "Failed to fetch customer journey",
    });
  }
};
